module.exports = __webpack_public_path__ + "img/logo_jpn.bc2d5c60.png";